module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "320"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.appointmentId) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "flat": "",
            "loading": _vm.request.loading,
            "disabled": _vm.disabled
          },
          on: {
            "click": function($event) {
              _vm.step = 0
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(_vm.cta))]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-1 overline"
  }, [_vm._v("\n            Please confirm\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n            This will copy the codes from this appointment to all the appointments in the recurring series\n            "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Clear any existing codes on other appointments"
    },
    model: {
      value: (_vm.withClear),
      callback: function($$v) {
        _vm.withClear = $$v
      },
      expression: "withClear"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Ignore invoiced and paid appointments"
    },
    model: {
      value: (_vm.excludeInvoiced),
      callback: function($$v) {
        _vm.excludeInvoiced = $$v
      },
      expression: "excludeInvoiced"
    }
  }), _vm._v(" "), (_vm.afterDate) ? _c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "hint": ("Only update appointments after " + _vm.afterDate),
      "label": "Only apply to appointments after this one"
    },
    model: {
      value: (_vm.onlyAfter),
      callback: function($$v) {
        _vm.onlyAfter = $$v
      },
      expression: "onlyAfter"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Apply Codes")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n            Codes successfully copied\n          ")]), _vm._v(" "), (_vm.request.result) ? _c('v-card-text', [_vm._v("\n            Codes copied to " + _vm._s(_vm.request.result.clone_count) + " appointments\n          ")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.step = 0;
        _vm.dialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79202694","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/ApplyAppointmentCodes.vue
// module id = 1473
// module chunks = 9